import React from "react"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"
import { CircularProgressbarWithChildren } from "react-circular-progressbar"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Nav from "../components/nav"

export default ({ data }) => {
  let level = "初級"
  let percentage = 25
  let skillName = ""

  function judgeLevel(value, name) {
    switch (value) {
      case "初級":
        level = "初級"
        percentage = 25
        skillName = name
        break
      case "中級":
        level = "中級"
        percentage = 50
        skillName = name
        break
      case "上級":
        level = "上級"
        percentage = 75
        skillName = name
        break
      case "達人":
        level = "達人"
        percentage = 100
        skillName = name
        break
      default:
        level = "初級"
        percentage = 25
        skillName = name
        break
    }
  }

  return (
    <Layout>
      <SEO />

      <section id="section1" className="section section1">
        <div className="content">
          <h1>
            <svg
              id="logo"
              className="logo"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1005 293"
            >
              <g
                id="グループ_45"
                data-name="グループ 45"
                transform="translate(-575.5 -615.186)"
              >
                <g
                  id="グループ_42"
                  data-name="グループ 42"
                  transform="translate(913.889 686.274)"
                >
                  <path
                    id="パス_7"
                    data-name="パス 7"
                    d="M780.424,686.184H791.7l1.367,13.665h.512c8.029-8.882,17.936-16.057,28.7-16.057,14.349,0,21.866,7,25.453,17.936,9.907-10.589,19.646-17.936,30.749-17.936,18.792,0,28.016,12.471,28.016,36.044v26.138c0,6.6-14.009,6.6-14.009,0v-24.43c0-17.765-5.637-25.624-17.936-25.624-7.518,0-15.375,4.954-24.258,15.032v48.688c0,6.6-13.836,6.6-13.836,0v-38.1c0-17.765-5.639-25.624-18.108-25.624-7.176,0-15.375,4.954-24.087,15.032v67.478H780.424Z"
                    transform="translate(-772.309 -641.343)"
                    fill="#6bab93"
                  />
                  <circle
                    id="楕円形_4"
                    data-name="楕円形 4"
                    cx="12.811"
                    cy="12.811"
                    r="12.811"
                    transform="translate(0 31.801)"
                    fill="#6bab93"
                  />
                  <circle
                    id="楕円形_5"
                    data-name="楕円形 5"
                    cx="12.811"
                    cy="12.811"
                    r="12.811"
                    transform="translate(2.562 124.896)"
                    fill="#6bab93"
                  />
                  <circle
                    id="楕円形_6"
                    data-name="楕円形 6"
                    cx="12.811"
                    cy="12.811"
                    r="12.811"
                    transform="translate(439.556 114.547)"
                    fill="#f2a61c"
                  />
                  <path
                    id="パス_8"
                    data-name="パス 8"
                    d="M868.823,754.685c0-20.158,17.594-30.065,57.227-34.507.171-12.47-3.758-24.768-19.646-24.768a43.608,43.608,0,0,0-26.307,8.541c-3.842,2.5-10.674-6.04-5.637-9.738a60.949,60.949,0,0,1,34.165-10.42c22.38,0,31.263,15.2,31.263,37.41v53.811c-.43,4.889-10.679,4.889-11.446,0l-1.2-7.859h-.513c-8.882,7.518-19.473,13.5-31.09,13.5C880.438,780.651,868.823,771.425,868.823,754.685Zm57.227,1.879V729.575c-32.628,3.758-43.731,11.614-43.731,24.256,0,11.1,7.687,15.546,17.082,15.546S916.655,764.936,926.05,756.564Z"
                    transform="translate(-709.708 -641.343)"
                    fill="#6bab93"
                  />
                  <path
                    id="パス_9"
                    data-name="パス 9"
                    d="M924.677,769.719c-4.694-3.481.43-13.73,7-9.395,8.03,6.491,12.811,9.393,24.429,9.393,12.813,0,19.133-6.833,19.133-15.373,0-9.907-11.1-14.349-21.525-18.108-13.153-4.781-27.332-10.932-27.332-26.648,0-14.35,11.446-25.795,31.432-25.795,11.1,0,17.6,2.9,24.6,8.541,4.185,3.869-.94,12.41-6.833,9.055-6.32-4.614-9.395-6.493-17.767-6.493-12.3,0-17.936,6.493-17.936,14.009,0,9.224,9.566,12.811,20.156,16.569,13.5,5.3,28.528,10.591,28.528,28.187,0,14.692-11.615,26.991-32.969,26.991C942.443,780.651,933.388,776.895,924.677,769.719Z"
                    transform="translate(-671.443 -641.343)"
                    fill="#6bab93"
                  />
                  <path
                    id="パス_10"
                    data-name="パス 10"
                    d="M974.522,663.469c0-6.037,13.838-6.037,13.838,0V697.8l-.514,19.3c8.882-8.543,18.279-15.717,30.921-15.717,19.3,0,28.186,12.471,28.186,36.044v55.177c0,6.6-14.007,6.6-14.007,0V739.144c0-17.765-5.468-25.624-18.281-25.624-9.736,0-16.74,5.125-26.306,15.032v64.061c0,6.6-13.838,6.6-13.838,0Z"
                    transform="translate(-634.856 -658.942)"
                    fill="#6bab93"
                  />
                  <path
                    id="パス_11"
                    data-name="パス 11"
                    d="M1039.042,757.025c.091,4.207,9.568,4.207,9.568,0l1.879-73.967.34-16.742c0-5.866-14.007-5.866-14.007,0l.342,16.742Z"
                    transform="translate(-590.738 -656.835)"
                    fill="#6bab93"
                  />
                  <path
                    id="パス_12"
                    data-name="パス 12"
                    d="M1066.121,663.469c0-6.037,13.665-6.037,13.665,0v90.709h.513l40.658-50.394c5.041-5.355,10.156,1.107,10.165,6.6l-25.2,30.467,30.323,48.109c3.416,6.833-6.833,11.957-10.678,7.068l-27.845-45.611-17.938,21.012v21.183c0,8.305-13.665,8.305-13.665,0Z"
                    transform="translate(-569.989 -658.942)"
                    fill="#6bab93"
                  />
                  <path
                    id="パス_13"
                    data-name="パス 13"
                    d="M1116.221,732.308c0-30.75,19.815-48.515,42.363-48.515s42.537,17.765,42.537,48.515c0,30.576-19.986,48.343-42.537,48.343S1116.221,762.885,1116.221,732.308Zm70.549,0c0-21.866-11.614-36.729-28.186-36.729s-28.014,14.863-28.014,36.729c0,22.035,11.445,36.726,28.014,36.726S1186.77,754.344,1186.77,732.308Z"
                    transform="translate(-534.509 -641.343)"
                    fill="#6bab93"
                  />
                </g>
                <g
                  id="グループ_44"
                  data-name="グループ 44"
                  transform="translate(580.5 620.186)"
                >
                  <path
                    id="パス_20"
                    data-name="パス 20"
                    d="M141.5,0A141.5,141.5,0,1,1,0,141.5,141.5,141.5,0,0,1,141.5,0Z"
                    transform="translate(0 0)"
                    fill="none"
                    stroke="#6bab93"
                    strokeWidth={10}
                  />
                  <g
                    id="グループ_43"
                    data-name="グループ 43"
                    transform="translate(12.811 13.234)"
                  >
                    <path
                      id="パス_14"
                      data-name="パス 14"
                      d="M751.3,753.152c-1.831,6.4-4.465,8.23-15.742,9.246H685.594l-12.76-22.1h74.112C751,745.023,752.378,749.39,751.3,753.152Zm-16.328,27.618c.955-3.514-.506-7.246-4.443-11.535H689.542l11.383,19.717h19.442C728.956,788.951,733.443,786.411,734.975,780.769ZM788.725,720.5l-107.707.014-19.6,0,6.981,12.092h96.891a10.1,10.1,0,0,1,7.562-4.129c3.867,0,5.924,3.268,4.61,7.241-1.291,3.912-5.374,7.041-9.137,7.041a4.678,4.678,0,0,1-4.778-3.333l-10.479.212-.079.282c3.478,4.363,5.7,9.648,4.026,15.264-2.178,7.3-11.028,13.881-21.5,12.8,4.025,4.8,6.383,9.432,4.913,14.6-2.415,8.5-9.518,12.558-20.761,12.558H704.5l8.257,14.3a129.128,129.128,0,0,0,15.365-7.55A127.735,127.735,0,0,0,788.725,720.5Z"
                      transform="translate(-536.01 -562.494)"
                      fill="#6bab93"
                    />
                    <path
                      id="パス_15"
                      data-name="パス 15"
                      d="M685.419,804.46c-6.46,1.616-9.359.249-15.877-9.011l-24.984-43.273,12.76-22.1,37.055,64.184C692.312,800.137,689.215,803.511,685.419,804.46Zm-32.081-.331c3.521-.929,6.021-4.062,7.767-9.615l-20.494-35.5-11.383,19.717,9.719,16.836C643.241,803.007,647.686,805.624,653.338,804.129Zm79.069,16.414-53.865-93.271-9.8-16.976-6.981,12.092L710.2,806.3a10.1,10.1,0,0,1,7.356,4.486c1.934,3.348.133,6.763-3.963,7.613-4.035.837-8.787-1.134-10.667-4.392a4.681,4.681,0,0,1,.5-5.806L698,799.23l-.282.072c-2.041,5.2-5.5,9.766-11.205,11.12-7.408,1.763-17.536-2.608-21.832-12.22-2.147,5.886-4.978,10.244-10.191,11.558-8.568,2.156-15.635-1.964-21.258-11.7l-7.581-13.131-8.257,14.3a128.124,128.124,0,0,0,115.014,21.313Z"
                      transform="translate(-567.185 -569.72)"
                      fill="#6bab93"
                    />
                    <path
                      id="パス_16"
                      data-name="パス 16"
                      d="M618.626,754.593c-4.629-4.786-4.894-7.98-.135-18.255l24.984-43.273h25.518l-37.055,64.183C625.815,758.4,621.345,757.4,618.626,754.593Zm-15.754-27.949c2.567,2.584,6.529,3.184,12.213,1.92l20.495-35.5H612.811L603.092,709.9C598.8,717.34,598.753,722.5,602.871,726.644Zm25.322,76.683,53.841-93.283,9.8-16.979H677.872l-48.445,83.909a10.1,10.1,0,0,1-.207,8.614c-1.934,3.348-5.791,3.5-8.577.374-2.742-3.076-3.409-8.177-1.529-11.434a4.677,4.677,0,0,1,5.276-2.472l5.054-9.181-.2-.21c-5.519.832-11.207.116-15.233-4.144-5.229-5.534-6.506-16.491-.331-25.016-6.172,1.083-11.361.811-15.1-3.047-6.153-6.342-6.117-14.523-.5-24.261l7.581-13.131H589.143A129.254,129.254,0,0,0,588,710.147,127.734,127.734,0,0,0,628.193,803.327Z"
                      transform="translate(-588 -581.923)"
                      fill="#6bab93"
                    />
                    <path
                      id="パス_17"
                      data-name="パス 17"
                      d="M627.436,689.9c1.831-6.4,4.465-8.23,15.742-9.246h49.967l12.76,22.1H631.793C627.735,698.029,626.361,693.661,627.436,689.9Zm16.328-27.617c-.955,3.514.505,7.246,4.443,11.535H689.2L677.815,654.1H658.372C649.784,654.1,645.3,656.64,643.764,662.282Zm-53.749,60.269,107.707-.014,19.6,0-6.981-12.092H613.453a10.1,10.1,0,0,1-7.562,4.129c-3.867,0-5.924-3.268-4.61-7.241,1.291-3.912,5.374-7.041,9.137-7.041a4.678,4.678,0,0,1,4.778,3.333l10.48-.212.08-.282c-3.48-4.363-5.705-9.648-4.028-15.264,2.178-7.3,11.028-13.881,21.5-12.8-4.024-4.8-6.383-9.433-4.913-14.6,2.415-8.5,9.518-12.558,20.761-12.558h15.163l-8.257-14.3a129.136,129.136,0,0,0-15.365,7.55A127.741,127.741,0,0,0,590.015,722.551Z"
                      transform="translate(-586.573 -624.033)"
                      fill="#6bab93"
                    />
                    <path
                      id="パス_18"
                      data-name="パス 18"
                      d="M688.628,649.486c6.46-1.616,9.359-.249,15.877,9.011l24.984,43.273-12.76,22.1-37.055-64.184C681.736,653.809,684.833,650.435,688.628,649.486Zm32.081.331c-3.521.929-6.021,4.062-7.767,9.615l20.495,35.5,11.383-19.717L735.1,658.378C730.806,650.939,726.362,648.322,720.709,649.817ZM641.64,633.4l53.865,93.269,9.8,16.977,6.981-12.092-48.445-83.91a10.1,10.1,0,0,1-7.355-4.486c-1.934-3.348-.133-6.762,3.963-7.613,4.035-.837,8.787,1.134,10.668,4.392a4.681,4.681,0,0,1-.5,5.806l5.424,8.97.282-.072c2.041-5.2,5.5-9.766,11.206-11.12,7.408-1.763,17.536,2.608,21.832,12.22,2.147-5.886,4.978-10.244,10.191-11.557,8.568-2.156,15.635,1.964,21.258,11.7L748.4,669.02l8.257-14.3A128.123,128.123,0,0,0,641.64,633.4Z"
                      transform="translate(-550.014 -628)"
                      fill="#6bab93"
                    />
                    <path
                      id="パス_19"
                      data-name="パス 19"
                      d="M750.42,697.184c4.631,4.786,4.9,7.98.137,18.255l-24.984,43.273H700.055L737.11,694.53C743.232,693.376,747.7,694.372,750.42,697.184Zm15.756,27.949c-2.567-2.585-6.529-3.184-12.213-1.92l-20.495,35.5h22.768l9.719-16.836C770.25,734.437,770.294,729.28,766.176,725.133ZM740.854,648.45l-53.841,93.283-9.8,16.979h13.963L739.621,674.8a10.1,10.1,0,0,1,.207-8.614c1.934-3.348,5.791-3.5,8.577-.374,2.742,3.076,3.409,8.177,1.529,11.434a4.677,4.677,0,0,1-5.276,2.472L739.6,688.9l.2.21c5.519-.832,11.207-.116,15.233,4.144,5.229,5.535,6.506,16.491.331,25.016,6.172-1.083,11.361-.811,15.1,3.047,6.153,6.342,6.117,14.523.5,24.261l-7.581,13.131H779.9a129.254,129.254,0,0,0,1.143-17.082A127.734,127.734,0,0,0,740.854,648.45Z"
                      transform="translate(-524.822 -613.518)"
                      fill="#6bab93"
                    />
                  </g>
                </g>
              </g>
            </svg>
          </h1>
          <div className="scroll-icon" />
        </div>
      </section>
      <section id="section2" className="section section2">
        <div className="content">
          <h2>自己紹介</h2>
          <div className="intro">
            <div className="intro-img">
              <figure className="profile-image">
                <Img fluid={data.file.childImageSharp.fluid} alt="" />
              </figure>
            </div>
            <p className="intro-text">
              ニックネームはUkkyon。好きな言葉は「思い立ったが吉日」。「腹が減っては軍は出来ぬ」なので、ハングリー精神でやりたいことが多すぎて、かえってやる気が起きません。
              <br />
              割とこの業界の仕事は楽しいので、苦じゃないです。沢山お仕事ください。
              <br />
              Web関係とPythonであればお仕事をさせていただきたいです。ここに書いていない言語や実績もありますので、是非、お問い合わせください。
            </p>
          </div>
          <h3>経歴</h3>
          <table className="career-table">
            <tbody>
              <tr>
                <th className="career-date">2017年3月</th>
                <td className="career-detail">
                  栃木県立那須拓陽高等学校 普通科 卒業
                </td>
              </tr>
              <tr>
                <th className="career-date">2018年4月</th>
                <td className="career-detail">HAL東京 高度情報処理学科 入学</td>
              </tr>
              <tr>
                <th className="career-date">2019年3月</th>
                <td className="career-detail">
                  全研本社株式会社(アルバイト) イノベーション事業部
                  コーダーとして従事
                </td>
              </tr>
              <tr>
                <th className="career-date">2020年1月</th>
                <td className="career-detail">
                  全研本社株式会社 コミュニケーションプロダクツ事業部
                  プログラマーとして従事
                </td>
              </tr>
              <tr>
                <th className="career-date">2020年7月</th>
                <td className="career-detail">全研本社株式会社 契約解除</td>
              </tr>
              <tr>
                <th className="career-date">2021年現在</th>
                <td className="career-detail">
                  HAL東京 高度情報処理学科 4年次在学
                </td>
              </tr>
            </tbody>
          </table>
          <h3>実績</h3>
          <ul>
            <li>WordPressのテーマ制作</li>
            <li>コレスポンデンス分析による文書分類</li>
            <li>共起ネットワークで文章の関連性の分析</li>
            <li>水量管理システムのフロントコーディング</li>
            <li>アプリケーションの自動操作</li>
            <li>Webサイト制作</li>
            <li>倉庫管理システムのハンディ開発</li>
          </ul>
          <p>などなど</p>
        </div>
      </section>
      <section id="section3" className="section section3">
        <div className="content">
          <h2>スキル</h2>
          <div className="skill-table">
            <div className="skill-card" onLoad={judgeLevel("上級", "HTML")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={50}
                    viewBox="221.807 89.47 440 621.061"
                    enableBackground="new 221.807 89.47 440 621.061"
                  >
                    <filter id="a" width="150%" height="150%" x="-5%" y="-5%">
                      <feFlood
                        floodColor="#000"
                        result="floodFill"
                        floodOpacity=".5"
                      />
                      <feComposite
                        in="floodFill"
                        in2="SourceAlpha"
                        operator="in"
                        result="coloredAlpha"
                      />
                      <feGaussianBlur
                        in="coloredAlpha"
                        result="blur"
                        stdDeviation={8}
                      />
                      <feComposite
                        in="blur"
                        in2="SourceGraphic"
                        operator="out"
                        result="maskedOffsetBlur"
                      />
                      <feMerge>
                        <feMergeNode in="maskedOffsetBlur" />
                        <feMergeNode in="SourceGraphic" />
                      </feMerge>
                    </filter>
                    <g filter="url(#a)">
                      <path
                        fill="#e44d26"
                        d="M261.849 660.647l-40.042-449.125h440l-40.086 449.054-180.184 49.954z"
                      />
                      <path
                        fill="#f16529"
                        d="M441.807 672.348l145.596-40.367 34.258-383.735H441.807z"
                      />
                      <path
                        fill="#ebebeb"
                        d="M441.807 414.82h-72.888l-5.035-56.406h77.923V303.33H303.683l1.32 14.778 13.538 151.794h123.266zM441.807 557.876l-.242.066-61.346-16.566-3.922-43.93h-55.294l7.718 86.489 112.834 31.323.252-.071z"
                      />
                      <path d="M262.745 89.47h27.992v27.656h25.606V89.47h27.993v83.75h-27.993v-28.044h-25.606v28.044h-27.99l-.002-83.75zM381.149 117.244h-24.642V89.47H433.8v27.774h-24.654v55.976H381.15v-55.976h-.001zM446.065 89.47h29.19l17.955 29.428 17.938-29.428h29.2v83.75h-27.882v-41.512l-19.259 29.778h-.481l-19.272-29.778v41.512h-27.39V89.47zM554.277 89.47h28v56.068h39.368v27.682h-67.368V89.47z" />
                      <path
                        fill="#fff"
                        d="M441.617 414.82v55.082h67.83l-6.395 71.44-61.435 16.58v57.307l112.924-31.294.826-9.309 12.946-145.014 1.344-14.792h-14.842zM441.617 303.33v55.084H574.67l1.103-12.382 2.51-27.924 1.318-14.778z"
                      />
                    </g>
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div className="skill-card" onLoad={judgeLevel("上級", "HTML")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    enableBackground="new 0 0 1771 2499.8"
                    width={50}
                    viewBox="0 0 1771 2499.8"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m1387.8 92.5h-146.9l152.8 165.9v78.9h-314.8v-92.4h152.8l-152.8-165.9v-79h309zm-371.4 0h-147.1l153 165.9v78.9h-314.9v-92.4h152.8l-152.8-165.9v-79h309zm-367.8 3.8h-158.5v144.8h158.5v96.3h-271.3v-337.4h271.3z"
                      fill="#131313"
                    />
                    <path
                      d="m161.2 2299.1-161.2-1807.7h1771l-161.4 1807.4-725.2 201z"
                      fill="#1572b6"
                    />
                    <path
                      d="m885.5 2346.2 586-162.5 137.8-1544.5h-723.8z"
                      fill="#33a9dc"
                    />
                    <path
                      d="m885.5 1294.1h293.4l20.2-227h-313.6v-221.6h556l-5.3 59.5-54.5 611h-496.2z"
                      fill="#fff"
                    />
                    <path
                      d="m886.7 1869.9h-1l-246.9-66.7-15.8-176.8h-222.4l31.1 348.1 454.2 126.4h1.3v-231z"
                      fill="#ebebeb"
                    />
                    <path
                      d="m1160.1 1506.3-26.7 296.7-247.3 66.7v231l454.5-126 3.3-37.5 38.6-431h-222.4z"
                      fill="#fff"
                    />
                    <path
                      d="m886.3 845.5v221.7h-535.4l-4.6-49.8-10.1-112.4-5.3-59.5zm-.8 448.6v221.7h-244.1l-4.3-49.8-10.1-112.4-5.3-59.5h263.7z"
                      fill="#ebebeb"
                    />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div className="skill-card" onLoad={judgeLevel("上級", "Sass")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={50}
                    viewBox="0 0 512 384"
                  >
                    <path
                      fill="#CF649A"
                      d="M440.6 220.6c-17.9.101-33.4 4.4-46.4 10.801-4.8-9.5-9.6-17.801-10.399-24-.9-7.2-2-11.601-.9-20.2C384 178.6 389 166.4 389 165.4c-.101-.9-1.101-5.3-11.4-5.4s-19.2 2-20.2 4.7-3 8.9-4.3 15.3c-1.8 9.4-20.6 42.7-31.3 60.2-3.5-6.8-6.5-12.8-7.101-17.601-.899-7.199-2-11.6-.899-20.199 1.1-8.601 6.1-20.8 6.1-21.8-.1-.9-1.1-5.3-11.399-5.4-10.301-.1-19.2 2-20.2 4.7s-2.1 9.1-4.3 15.3C281.9 201.4 256.9 257 250.4 271.5c-3.3 7.4-6.199 13.3-8.3 17.3-2.1 4-.1.3-.3.7-1.8 3.4-2.8 5.3-2.8 5.3v.101c-1.4 2.5-2.9 4.899-3.601 4.899-.5 0-1.5-6.7.2-15.899 3.7-19.301 12.7-49.4 12.601-50.5 0-.5 1.699-5.801-5.801-8.5-7.3-2.7-9.899 1.8-10.5 1.8-.6 0-1.1 1.6-1.1 1.6s8.1-33.899-15.5-33.899c-14.8 0-35.2 16.1-45.3 30.8-6.4 3.5-20 10.899-34.4 18.8-5.5 3-11.2 6.2-16.6 9.1L117.9 251.9c-28.6-30.5-81.5-52.1-79.3-93.1.8-14.9 6-54.2 101.601-101.8 78.3-39 141-28.3 151.899-4.5 15.5 34-33.5 97.2-114.899 106.3-31 3.5-47.301-8.5-51.4-13-4.3-4.7-4.9-4.9-6.5-4-2.6 1.4-1 5.6 0 8.1 2.4 6.3 12.4 17.5 29.4 23.1 14.899 4.9 51.3 7.6 95.3-9.4 49.3-19.1 87.8-72.1 76.5-116.4-11.5-45.1-86.3-59.9-157-34.8C121.4 27.4 75.8 50.8 43 81.5 4 117.9-2.2 149.7.4 162.9c9.101 47.1 74 77.8 100 100.5-1.3.699-2.5 1.399-3.6 2-13 6.399-62.5 32.3-74.9 59.699-14 31 2.2 53.301 13 56.301 33.4 9.3 67.6-7.4 86.1-34.9 18.399-27.5 16.2-63.2 7.7-79.5l-.301-.6 10.2-6c6.601-3.9 13.101-7.5 18.8-10.601-3.199 8.7-5.5 19-6.699 34-1.4 17.601 5.8 40.4 15.3 49.4 4.2 3.899 9.2 4 12.3 4 11 0 16-9.101 21.5-20 6.8-13.3 12.8-28.7 12.8-28.7s-7.5 41.7 13 41.7c7.5 0 15-9.7 18.4-14.7v.1s.2-.3.6-1a36.13 36.13 0 0 0 1.2-1.899v-.2c3-5.2 9.7-17.1 19.7-36.8 12.899-25.4 25.3-57.2 25.3-57.2s1.2 7.8 4.9 20.6c2.199 7.601 6.999 15.9 10.699 24-3 4.2-4.8 6.601-4.8 6.601l.1.1c-2.399 3.2-5.1 6.601-7.899 10-10.2 12.2-22.4 26.101-24 30.101-1.9 4.699-1.5 8.199 2.2 11 2.7 2 7.5 2.399 12.6 2 9.2-.601 15.6-2.9 18.8-4.301 5-1.8 10.7-4.5 16.2-8.5 10-7.399 16.1-17.899 15.5-31.899-.3-7.7-2.8-15.3-5.9-22.5.9-1.3 1.801-2.601 2.7-4 15.8-23.101 28-48.5 28-48.5s1.2 7.8 4.9 20.6c1.899 6.5 5.7 13.601 9.1 20.601-14.8 12.1-24.1 26.1-27.3 35.3-5.9 17-1.3 24.7 7.4 26.5 3.899.8 9.5-1 13.699-2.8 5.2-1.7 11.5-4.601 17.301-8.9 10-7.4 19.6-17.7 19.1-31.6-.3-6.4-2-12.7-4.3-18.7 12.6-5.2 28.899-8.2 49.6-5.7 44.5 5.2 53.3 33 51.601 44.6-1.7 11.601-11 18-14.101 20-3.1 1.9-4.1 2.601-3.8 4 .4 2.101 1.8 2 4.5 1.601 3.7-.601 23.4-9.5 24.2-30.899 1.2-27.504-24.9-57.504-71.2-57.205zM97.4 336.3c-14.7 16.1-35.4 22.2-44.2 17-9.5-5.5-5.801-29.2 12.3-46.3 11-10.4 25.3-20 34.7-25.9 2.1-1.3 5.3-3.199 9.1-5.5.6-.399 1-.6 1-.6.7-.4 1.5-.9 2.3-1.4 6.7 24.4.3 45.8-15.2 62.7zm107.5-73.1c-5.1 12.5-15.9 44.6-22.4 42.8-5.601-1.5-9-25.8-1.101-49.8 4-12.101 12.5-26.5 17.5-32.101 8.101-9 16.9-12 19.101-8.3 2.6 4.801-9.9 39.601-13.1 47.401zm88.7 42.4c-2.2 1.101-4.2 1.9-5.1 1.301-.7-.4.899-1.9.899-1.9s11.1-11.9 15.5-17.4c2.5-3.199 5.5-6.899 8.7-11.1v1.2C313.6 292.1 299.8 301.7 293.6 305.6zm68.399-15.6c-1.6-1.2-1.399-4.9 4-16.5 2.101-4.6 6.9-12.3 15.2-19.6 1 3 1.601 5.899 1.5 8.6-.099 18-12.899 24.7-20.7 27.5z"
                    />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>

            <div
              className="skill-card"
              onLoad={judgeLevel("中級", "JavaScript")}
            >
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    width={50}
                    viewBox="0 0 256 256"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMin meet"
                  >
                    <path d="M0 0h256v256H0V0z" fill="#F7DF1E" />
                    <path d="M67.312 213.932l19.59-11.856c3.78 6.701 7.218 12.371 15.465 12.371 7.905 0 12.89-3.092 12.89-15.12v-81.798h24.057v82.138c0 24.917-14.606 36.259-35.916 36.259-19.245 0-30.416-9.967-36.087-21.996M152.381 211.354l19.588-11.341c5.157 8.421 11.859 14.607 23.715 14.607 9.969 0 16.325-4.984 16.325-11.858 0-8.248-6.53-11.17-17.528-15.98l-6.013-2.58c-17.357-7.387-28.87-16.667-28.87-36.257 0-18.044 13.747-31.792 35.228-31.792 15.294 0 26.292 5.328 34.196 19.247L210.29 147.43c-4.125-7.389-8.591-10.31-15.465-10.31-7.046 0-11.514 4.468-11.514 10.31 0 7.217 4.468 10.14 14.778 14.608l6.014 2.577c20.45 8.765 31.963 17.7 31.963 37.804 0 21.654-17.012 33.51-39.867 33.51-22.339 0-36.774-10.654-43.819-24.574" />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div
              className="skill-card"
              onLoad={judgeLevel("中級", "Gatsby.js")}
            >
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    enableBackground="new 0 0 2500 2500"
                    viewBox="0 0 2500 2500"
                    xmlns="http://www.w3.org/2000/svg"
                    width={50}
                  >
                    <path
                      d="m1250 0c-690.4 0-1250 559.6-1250 1250s559.6 1250 1250 1250 1250-559.6 1250-1250-559.6-1250-1250-1250zm-981.4 1263 968.4 968.4c-531.8-6.9-961.5-436.6-968.4-968.4zm1201.1 943.9-1176.6-1176.6c99.8-436.3 490.3-761.9 956.9-761.9 326.1 0 615.1 159.1 793.6 403.9l-135.9 119.9c-144.8-207.6-385.4-343.5-657.7-343.5-346.7 0-642 220.2-753.6 528.4l1026.5 1026.4c249.3-90.3 441-300.7 505.2-561.3h-425.4v-192.2h629c-.1 466.6-325.7 857.1-762 956.9z"
                      fill="#744c9e"
                    />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div className="skill-card" onLoad={judgeLevel("初級", "React.js")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    width={50}
                    viewBox="0 0 256 230"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMin meet"
                  >
                    <path
                      d="M.754 114.75c0 19.215 18.763 37.152 48.343 47.263-5.907 29.737-1.058 53.706 15.136 63.045 16.645 9.6 41.443 2.955 64.98-17.62 22.943 19.744 46.13 27.514 62.31 18.148 16.63-9.627 21.687-35.221 15.617-65.887 30.81-10.186 48.044-25.481 48.044-44.949 0-18.769-18.797-35.006-47.979-45.052 6.535-31.933.998-55.32-15.867-65.045-16.259-9.376-39.716-1.204-62.996 19.056C104.122 2.205 80.897-4.36 64.05 5.392 47.806 14.795 43.171 39.2 49.097 69.487 20.515 79.452.754 96.057.754 114.75z"
                      fill="#FFF"
                    />
                    <path
                      d="M201.025 79.674a151.364 151.364 0 0 0-7.274-2.292 137.5 137.5 0 0 0 1.124-4.961c5.506-26.728 1.906-48.26-10.388-55.348-11.787-6.798-31.065.29-50.535 17.233a151.136 151.136 0 0 0-5.626 5.163 137.573 137.573 0 0 0-3.744-3.458c-20.405-18.118-40.858-25.752-53.139-18.643-11.776 6.817-15.264 27.06-10.307 52.39a150.91 150.91 0 0 0 1.67 7.484c-2.894.822-5.689 1.698-8.363 2.63-23.922 8.34-39.2 21.412-39.2 34.97 0 14.004 16.4 28.05 41.318 36.566a128.44 128.44 0 0 0 6.11 1.91 147.813 147.813 0 0 0-1.775 8.067c-4.726 24.89-1.035 44.653 10.71 51.428 12.131 6.995 32.491-.195 52.317-17.525 1.567-1.37 3.14-2.823 4.715-4.346a148.34 148.34 0 0 0 6.108 5.573c19.204 16.525 38.17 23.198 49.905 16.405 12.12-7.016 16.058-28.247 10.944-54.078-.39-1.973-.845-3.988-1.355-6.04 1.43-.422 2.833-.858 4.202-1.312 25.904-8.582 42.757-22.457 42.757-36.648 0-13.607-15.77-26.767-40.174-35.168z"
                      fill="#53C1DE"
                    />
                    <path
                      d="M195.406 142.328c-1.235.409-2.503.804-3.795 1.187-2.86-9.053-6.72-18.68-11.442-28.625 4.507-9.71 8.217-19.213 10.997-28.208 2.311.67 4.555 1.375 6.717 2.12 20.91 7.197 33.664 17.84 33.664 26.04 0 8.735-13.775 20.075-36.14 27.486zm-9.28 18.389c2.261 11.422 2.584 21.749 1.086 29.822-1.346 7.254-4.052 12.09-7.398 14.027-7.121 4.122-22.35-1.236-38.772-15.368-1.883-1.62-3.78-3.35-5.682-5.18 6.367-6.964 12.73-15.06 18.94-24.05 10.924-.969 21.244-2.554 30.603-4.717.46 1.86.87 3.683 1.223 5.466zm-93.85 43.137c-6.957 2.457-12.498 2.527-15.847.596-7.128-4.11-10.09-19.98-6.049-41.265a138.507 138.507 0 0 1 1.65-7.502c9.255 2.047 19.5 3.52 30.45 4.408 6.251 8.797 12.798 16.883 19.396 23.964a118.863 118.863 0 0 1-4.305 3.964c-8.767 7.664-17.552 13.1-25.294 15.835zm-32.593-61.58c-11.018-3.766-20.117-8.66-26.354-14-5.604-4.8-8.434-9.565-8.434-13.432 0-8.227 12.267-18.722 32.726-25.855a139.276 139.276 0 0 1 7.777-2.447c2.828 9.197 6.537 18.813 11.013 28.537-4.534 9.869-8.296 19.638-11.15 28.943a118.908 118.908 0 0 1-5.578-1.746zm10.926-74.37c-4.247-21.703-1.427-38.074 5.67-42.182 7.56-4.376 24.275 1.864 41.893 17.507 1.126 1 2.257 2.047 3.39 3.13-6.564 7.049-13.051 15.074-19.248 23.82-10.627.985-20.8 2.567-30.152 4.686a141.525 141.525 0 0 1-1.553-6.962zm97.467 24.067a306.982 306.982 0 0 0-6.871-11.3c7.21.91 14.117 2.12 20.603 3.601-1.947 6.241-4.374 12.767-7.232 19.457a336.42 336.42 0 0 0-6.5-11.758zm-39.747-38.714c4.452 4.823 8.911 10.209 13.297 16.052a284.245 284.245 0 0 0-26.706-.006c4.39-5.789 8.887-11.167 13.409-16.046zm-40.002 38.78a285.24 285.24 0 0 0-6.378 11.685c-2.811-6.667-5.216-13.222-7.18-19.552 6.447-1.443 13.322-2.622 20.485-3.517a283.79 283.79 0 0 0-6.927 11.384zm7.133 57.683c-7.4-.826-14.379-1.945-20.824-3.348 1.995-6.442 4.453-13.138 7.324-19.948a283.494 283.494 0 0 0 6.406 11.692 285.27 285.27 0 0 0 7.094 11.604zm33.136 27.389c-4.575-4.937-9.138-10.397-13.595-16.27 4.326.17 8.737.256 13.22.256 4.606 0 9.159-.103 13.64-.303-4.4 5.98-8.843 11.448-13.265 16.317zm46.072-51.032c3.02 6.884 5.566 13.544 7.588 19.877-6.552 1.495-13.625 2.699-21.078 3.593a337.537 337.537 0 0 0 6.937-11.498 306.632 306.632 0 0 0 6.553-11.972zm-14.915 7.15a316.478 316.478 0 0 1-10.84 17.49c-6.704.479-13.632.726-20.692.726-7.031 0-13.871-.219-20.458-.646A273.798 273.798 0 0 1 96.72 133.28a271.334 271.334 0 0 1-9.64-18.206 273.864 273.864 0 0 1 9.611-18.216v.002a271.252 271.252 0 0 1 10.956-17.442c6.72-.508 13.61-.774 20.575-.774 6.996 0 13.895.268 20.613.78a290.704 290.704 0 0 1 10.887 17.383 316.418 316.418 0 0 1 9.741 18.13 290.806 290.806 0 0 1-9.709 18.29zm19.913-107.792c7.566 4.364 10.509 21.961 5.755 45.038a127.525 127.525 0 0 1-1.016 4.492c-9.374-2.163-19.554-3.773-30.212-4.773-6.209-8.841-12.642-16.88-19.1-23.838a141.92 141.92 0 0 1 5.196-4.766c16.682-14.518 32.273-20.25 39.377-16.153z"
                      fill="#FFF"
                    />
                    <path
                      d="M128.221 94.665c11.144 0 20.177 9.034 20.177 20.177 0 11.144-9.033 20.178-20.177 20.178-11.143 0-20.177-9.034-20.177-20.178 0-11.143 9.034-20.177 20.177-20.177"
                      fill="#53C1DE"
                    />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div className="skill-card" onLoad={judgeLevel("中級", "Vue.js")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    width={50}
                    viewBox="0 0 256 221"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMin meet"
                  >
                    <path
                      d="M204.8 0H256L128 220.8 0 0h97.92L128 51.2 157.44 0h47.36z"
                      fill="#41B883"
                    />
                    <path
                      d="M0 0l128 220.8L256 0h-51.2L128 132.48 50.56 0H0z"
                      fill="#41B883"
                    />
                    <path
                      d="M50.56 0L128 133.12 204.8 0h-47.36L128 51.2 97.92 0H50.56z"
                      fill="#35495E"
                    />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div className="skill-card" onLoad={judgeLevel("中級", "Gulp.js")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    width={25}
                    viewBox="0 0 256 566"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMin meet"
                  >
                    <path
                      d="M197.28 548.749l5.427-90.43 14.985-25.58s-34.106 13.952-91.205 13.952c-57.1 0-90.689-13.694-90.689-13.694l16.794 27.904 5.941 87.848c0 9.418 31.059 17.052 69.374 17.052 38.313 0 69.373-7.634 69.373-17.052M180.161 126.454l11.391-45.025 63.081-66.376L238.007.892l-66.784 70.707-13.226 53.793a886.14 886.14 0 0 0-29.873-.497c-70.336 0-127.355 8.016-127.355 17.902 0 9.887 57.019 17.902 127.355 17.902 70.335 0 127.353-8.015 127.353-17.902 0-7.28-30.924-13.546-75.316-16.343"
                      fill="#D34A47"
                    />
                    <path
                      d="M173.535 151.669s-2.467.553-9.724.584c-7.259.03-12.413-.047-14.466-1.917-.552-.502-.854-1.499-.851-2.174.006-1.285.918-2.042 2.08-2.516l1.099 1.724c-.478.165-.751.36-.752.568-.004.976 7.422 1.644 13.102 1.572 5.681-.07 12.545-.538 12.551-1.5 0-.291-.519-.565-1.422-.781l1.094-1.712c1.472.457 2.757 1.34 2.754 2.868-.014 2.598-3.32 2.993-5.465 3.284"
                      fill="#FFF"
                    />
                    <path
                      d="M254.509 15.184c1.586-1.832-.821-6.518-5.376-10.465C244.576.774 239.596-.94 238.007.892c-1.587 1.832.821 6.518 5.378 10.463 4.555 3.946 9.537 5.662 11.124 3.829M194.246 327.865c-1.495-14.384 31.462-35.216 23.004-35.883-18.208 1.041-27.27 21.338-36.431 42.596-3.357 7.791-14.844 41.013-22.378 36.923-7.532-4.088 9.765-31.407 14.613-47.631-5.594 4.102-26.109 20.041-31.396 5.114-8.5 7.219-26.663 11.13-24.614-7.833-4.522 8.01-14.671 19.193-26.853 14.546-15.998-6.101 9.27-57.062 15.553-54.491 6.284 2.57-1.268 14.179-3.246 18.687-4.35 9.921-9.375 22.393-6.018 24.946 5.751 4.374 21.401-16.547 21.749-17.007 2.927-3.867 11.266-29.166 17.987-26.261 6.721 2.905-16.764 36.308-7.983 42.937 1.771 1.338 9.017-.825 13.425-5.594 2.852-3.085 1.871-9.918 11.378-32.59 9.507-22.671 17.98-50.905 24.5-48.754 6.52 2.15 1.146 16.641-1.193 22.043-10.976 25.354-29.956 67.241-21.005 64.07 8.951-3.17 13.612-3.356 22.377-13.613 8.765-10.257 8.361-27.152 14.203-26.793 5.844.36 4.863 5.777 3.446 9.902 5.75-6.58 27.256-20.438 32.448-6.713 6.15 16.249-30.769 39.72-21.564 38.523 8.975-1.167 23.515-10.376 29.723-18.749l17.088-153.626s-17.195 14.23-126.589 14.23c-109.395 0-124.811-13.934-124.811-13.934l14.548 140.224c7.722-21.947 26.059-66.339 54.963-64.849 13.148.678 30.7 25.995 15.665 26.853-6.364.362-7.01-12.637-14.546-14.546-5.438-1.378-13.009 3.043-17.902 7.833-9.758 9.55-30.745 47.229-27.972 66.014 3.533 23.949 33.048-8.322 38.042-17.903 3.517-6.749 5.893-26.745 13.585-24.647 7.693 2.098-.671 22.734-6.247 40.979-6.264 20.487-9.557 42.098-17.408 39.612-7.852-2.484 4.938-28.932 4.475-33.566-7.38 6.809-20.976 24.047-38.37 15.515l9.035 87.078s24.013 18.973 96.35 18.973c72.337 0 97.239-18.677 97.239-18.677l11.219-100.857c-9.179 8.938-38.229 24.81-40.089 6.919"
                      fill="#D34A47"
                    />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div className="skill-card" onLoad={judgeLevel("中級", "jQuery")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    width={50}
                    viewBox="0 0 512 116"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g fill="none" fillRule="evenodd">
                      <path
                        d="M489.718 8.646l21.42.118s-39.824 53.964-43.076 58.362c-1.056 1.424-2.66 2.96-3.474 4.864-2.057 4.786-4.169 15.285-4.169 15.285l-19.599.098s3.05-10.944 2.924-16.773c-.11-5.092-2.71-10.178-4.168-15.285-1.474-5.17-3.475-15.286-3.475-15.286h20.15l2.779 11.117 30.688-42.5"
                        fill="#1A1918"
                      />
                      <path
                        d="M449.157 20.027c3.953 2.383 6.379 15.529 6.379 15.529s-20.684.305-31.94.305h-9.727l-11.812 51.414h-18.064s11.242-55.874 13.896-66.004c.86-3.28 5.892-2.717 14.389-2.717h13.569c8.762 0 19.003-1.119 23.31 1.473M365.06 45.067s.563-3.3-1.91-7.122c-2.113-3.258-4.064-4.016-9.623-4.19-15.695-.493-15.39 11.138-15.39 11.138l26.923.174zm17.022-13.32c2.3 8.297-2.084 27.792-2.084 27.792s-22.894-.382-35.434 0c-3.899.119-8.566-.424-9.727 1.39-1.633 2.542.597 6.455 2.487 8.108 2.175 1.903 6.412 2.12 7.935 2.313 10.178 1.293 31.48.334 31.48.334l-3.69 16.34s-30.103 1.51-45.16-2.084c-2.973-.708-5.76-2.139-7.643-4.168-.514-.555-.96-1.312-1.446-1.966-.388-.522-1.52-2.237-2.028-3.593-3.439-9.164.403-26.72 4.169-36.128.437-1.09.986-2.473 1.564-3.648.722-1.465 1.333-3.119 1.91-3.995.388-.604.869-.993 1.272-1.563.465-.674 1.006-1.327 1.507-1.91 1.39-1.612 2.967-2.752 4.864-4.168 6.273-4.698 17.626-8.345 31.265-6.949 5.135.528 12.89 2.362 16.675 7.643 1.014 1.41 1.515 4.21 2.084 6.253zM299.229 18.49l17.516-.103s-9.762 46.307-14.737 68.888h-20.15c-14.082 0-26.623 1.744-31.959-8.338-5.176-9.789-.236-25.887 2.084-36.824 1.64-7.74 5.094-23.56 5.094-23.56l18.148-.166s-5.128 24.63-7.262 36.928c-.764 4.405-2.34 8.553-.694 11.81 1.563 3.1 3.752 3.322 10.421 3.475 2.113.05 9.033 0 9.033 0l12.506-52.11M217.244 51.84c1.834-6.516 4.509-13.582 4.169-19.454-.368-6.28-5.634-11.998-9.032-13.2-10.234-3.613-19.815 1.438-23.623 5.558-4.926 5.336-6.594 11.569-8.338 20.15-1.298 6.37-2.362 13.095 0 18.063 4.182 8.783 17.224 6.865 31.266 6.949 2.084-5.586 3.807-11.86 5.558-18.066zm24.318-25.706c2 14.548-5.676 30.606-10.964 44.57 5.392.487 10.117-.075 10.457.327.354.521-3.614 16.668-4.997 16.71-4.279.111-18.459.229-24.372.229-19.295 0-37.345 1.257-46.55-8.337-3.738-3.898-6.323-10.583-6.949-15.286-1.042-7.851.264-16.495 2.085-23.622 1.647-6.435 3.758-12.507 6.948-18.066C175.328 8.507 189.432-1.998 213.075.427c4.586.472 11.172 2.48 15.286 4.863.284.167 1.279.959 1.507 1.098 5.559 3.537 10.624 11.978 11.694 19.746zM156.193 18.574c-1.167 5.315-2.334 11.34-3.564 16.592h-19.454c1.507-5.822 2.661-11.61 4.169-16.675 6.225 0 12.013.083 18.85.083M132.48 40.03h18.76c-2.453 13.576-7.31 35.475-11.117 50.719-2.383 9.54-3.974 16.501-10.422 21.538-.577.452-.91.237-1.39.695-1.188 1.133-6.684 2.447-9.726 2.779-4.947.536-10.54.07-16.62-.055 1.591-5.815 3.391-12.798 4.809-18.01 14.82 1.794 15.195-12.214 18.064-25.706 1.66-7.796 6.691-28.834 7.642-31.96"
                        fill="#1A1918"
                      />
                      <g fill="#21609B">
                        <path d="M88.708 75.464l-.402 1.042c-6.85 13.34-18.989 21.524-36.303 21.885-8.094.167-15.806-1.91-20.844-4.168C20.287 89.338 11.142 80.279 6.148 70.6c-7.164-13.875-8.456-33.176 6.44-47.592.23 0-1.807 3.126-1.577 3.126l-.41 1.334C-.133 61.074 32.938 89.874 65.086 86.58c7.726-.792 17.578-5.023 23.622-11.116" />
                        <path d="M69.254 61.568c8.088.055 16.536-3.725 21.539-9.032-4.377 11.11-17.05 18.251-34.044 15.98-14.23-1.904-27.785-16.223-29.181-30.571-1.021-10.442 2.618-16.674 8.615-24.234-2.084 3.954-2.863 7.003-3.057 8.948-2.278 22.588 18.044 38.79 36.128 38.909" />
                        <path d="M89.98 33.512c-1.257 2.884-8.496 8.33-11.693 9.011-12.659 2.697-20.766-3.306-25.013-10.137-.631-1.02-1.798-3.806-2.007-4.515-1.647-5.6-.89-14.07 4.023-18.454-1.48 4.169-1.696 9.011-.917 12.159.472 1.903 1.91 5.226 3.349 7.316 2.618 3.807 4.279 4.732 7.642 6.754 1.515.91 3.14 1.64 3.842 1.84 3.189.939 9.922 3.412 20.775-3.974" />
                      </g>
                    </g>
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div className="skill-card" onLoad={judgeLevel("中級", "Python")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    width={50}
                    viewBox="0 0 256 255"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMinYMin meet"
                  >
                    <defs>
                      <linearGradient
                        x1="12.959%"
                        y1="12.039%"
                        x2="79.639%"
                        y2="78.201%"
                        id="a"
                      >
                        <stop stopColor="#3779b0" offset="0%" />
                        <stop stopColor="#366994" offset="100%" />
                      </linearGradient>
                      <linearGradient
                        x1="19.128%"
                        y1="20.579%"
                        x2="90.742%"
                        y2="88.429%"
                        id="b"
                      >
                        <stop stopColor="#FFE052" offset="0%" />
                        <stop stopColor="#FFC331" offset="100%" />
                      </linearGradient>
                    </defs>
                    <path
                      d="M126.916.072c-64.832 0-60.784 28.115-60.784 28.115l.072 29.128h61.868v8.745H41.631S.145 61.355.145 126.77c0 65.417 36.21 63.097 36.21 63.097h21.61v-30.356s-1.165-36.21 35.632-36.21h61.362s34.475.557 34.475-33.319V33.97S194.67.072 126.916.072zM92.802 19.66a11.12 11.12 0 0 1 11.13 11.13 11.12 11.12 0 0 1-11.13 11.13 11.12 11.12 0 0 1-11.13-11.13 11.12 11.12 0 0 1 11.13-11.13z"
                      fill="url(#a)"
                    />
                    <path
                      d="M128.757 254.126c64.832 0 60.784-28.115 60.784-28.115l-.072-29.127H127.6v-8.745h86.441s41.486 4.705 41.486-60.712c0-65.416-36.21-63.096-36.21-63.096h-21.61v30.355s1.165 36.21-35.632 36.21h-61.362s-34.475-.557-34.475 33.32v56.013s-5.235 33.897 62.518 33.897zm34.114-19.586a11.12 11.12 0 0 1-11.13-11.13 11.12 11.12 0 0 1 11.13-11.131 11.12 11.12 0 0 1 11.13 11.13 11.12 11.12 0 0 1-11.13 11.13z"
                      fill="url(#b)"
                    />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>

            <div className="skill-card" onLoad={judgeLevel("初級", "Android")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    width={50}
                    viewBox="32.9 57.77898118 414.2 366.56939652"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="m64.2 370.885c-10.7 0-17.9 8.4-17.9 19.2s7.2 19.2 17.9 19.2 17.9-8.4 17.9-19.2c-.1-10.8-7.3-19.2-17.9-19.2m-2.4-11.9c8.6 0 15.8 4.4 19.2 9.2v-8h13.2v59.9h-10.2a3.009 3.009 0 0 1 -3-3v-5c-3.4 4.8-10.5 9.2-19.2 9.2-16.4 0-28.9-14-28.9-31.1s12.4-31.2 28.9-31.2m47.4 1.2h13.2v8.1c3.6-6 10.4-9.3 18.2-9.3 13.9 0 22.9 9.8 22.9 25v36.1h-10.1a3.009 3.009 0 0 1 -3-3v-30.9c0-9.5-4.8-15.2-12.5-15.2-8.7 0-15.5 6.8-15.5 19.6v29.5h-10.1a3.009 3.009 0 0 1 -3-3zm95.9 10.7c-10.7 0-17.9 8.4-17.9 19.2s7.2 19.2 17.9 19.2 17.9-8.4 17.9-19.2-7.2-19.2-17.9-19.2m-2.4-11.9c8.6 0 15.8 4.4 19.2 9.2v-38h13.2v89.9h-10.1a3.009 3.009 0 0 1 -3-3v-5c-3.4 4.8-10.5 9.2-19.2 9.2-16.4 0-28.9-14-28.9-31.1s12.4-31.2 28.8-31.2m47.4 1.2h13.2v10.7a16.961 16.961 0 0 1 15.8-11.3 22.063 22.063 0 0 1 5.1.5v13.5a21.243 21.243 0 0 0 -6.6-1.1c-7.5 0-14.4 6.4-14.4 18.3v29.2h-10.1a3.009 3.009 0 0 1 -3-3zm69.6 48.8c10.5 0 18-8.3 18-18.9 0-10.7-7.4-18.9-18-18.9-10.7 0-18.1 8.3-18.1 18.9.1 10.7 7.4 18.9 18.1 18.9m0 12.3a31.151 31.151 0 1 1 31.4-31.1 30.948 30.948 0 0 1 -31.4 31.1m42.1-61.1h13.2v59.9h-10.1a3.009 3.009 0 0 1 -3-3zm6.6-13.1a8.985 8.985 0 0 1 -8.9-8.9 8.88 8.88 0 0 1 8.9-8.7 8.8 8.8 0 0 1 0 17.6m48.7 23.8c-10.7 0-17.9 8.4-17.9 19.2s7.2 19.2 17.9 19.2 17.9-8.4 17.9-19.2c-.2-10.8-7.2-19.2-17.9-19.2m-2.4-11.9c8.6 0 15.8 4.4 19.2 9.2v-38h13.2v89.9h-10.1a3.009 3.009 0 0 1 -3-3v-5c-3.4 4.8-10.5 9.2-19.2 9.2-16.4 0-28.9-14-28.9-31.1s12.4-31.2 28.8-31.2" />
                    <path
                      d="m341.5 129.185 34.5-59.7a7.17 7.17 0 0 0 -12.4-7.2l-34.9 60.4a216.078 216.078 0 0 0 -177.2 0l-34.9-60.4a7.17 7.17 0 0 0 -12.4 7.2l34.5 59.7c-59.5 32.2-99.9 92.1-105.8 162.8h414c-5.9-70.7-46.4-130.6-105.4-162.8zm-196.8 103.8a17.2 17.2 0 1 1 17.2-17.2 17.2 17.2 0 0 1 -17.2 17.2zm190.6 0a17.2 17.2 0 1 1 17.2-17.2 17.2 17.2 0 0 1 -17.2 17.2z"
                      fill="#3ddc84"
                    />
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
            <div className="skill-card" onLoad={judgeLevel("初級", "MySQL")}>
              <div className="skill-circle">
                <CircularProgressbarWithChildren value={percentage}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={50}
                    viewBox="0 0 192.756 192.756"
                  >
                    <g fillRule="evenodd" clipRule="evenodd">
                      <path fill="#fff" d="M0 0h192.756v192.756H0V0z" />
                      <path
                        d="M8.504 128.215h5.8v-22.977l9.058 20.033c1.026 2.408 2.499 3.301 5.354 3.301 2.856 0 4.239-.893 5.31-3.301l9.013-20.033v22.977h5.845v-22.977c0-2.23-.893-3.303-2.767-3.883-4.417-1.338-7.362-.178-8.7 2.811l-8.878 19.811-8.567-19.811c-1.294-2.988-4.284-4.148-8.745-2.811-1.829.58-2.722 1.652-2.722 3.883v22.977h-.001zM53.702 109.521h5.845v12.627c-.044.713.223 2.32 3.391 2.363 1.651.045 12.582 0 12.671 0v-15.08h5.845v20.658c0 5.086-6.291 6.201-9.236 6.246H53.835v-3.881h18.427c3.748-.402 3.302-2.275 3.302-2.9v-1.518H63.205c-5.756-.045-9.459-2.588-9.503-5.488 0-.267.133-12.939 0-13.027zM179.076 94.886c-3.568-.089-6.336.268-8.656 1.25-.668.269-1.74.269-1.828 1.116.357.355.4.936.713 1.428.535.893 1.473 2.096 2.32 2.721.938.715 1.875 1.428 2.855 2.053 1.74 1.07 3.703 1.695 5.398 2.766.982.625 1.963 1.428 2.945 2.098.49.357.803.938 1.428 1.16v-.135c-.312-.4-.402-.98-.713-1.428-.447-.445-.893-.848-1.34-1.293-1.293-1.74-2.9-3.258-4.641-4.506-1.428-.982-4.551-2.32-5.131-3.971l-.088-.09c.98-.09 2.141-.447 3.078-.715 1.518-.4 2.9-.312 4.461-.713.715-.179 1.428-.402 2.143-.625v-.401c-.803-.803-1.383-1.874-2.23-2.632-2.275-1.963-4.775-3.882-7.363-5.488-1.383-.892-3.168-1.473-4.639-2.23-.537-.268-1.428-.402-1.74-.848-.805-.981-1.25-2.275-1.83-3.436-1.293-2.454-2.543-5.175-3.658-7.763-.803-1.74-1.295-3.48-2.275-5.086-4.596-7.585-9.594-12.181-17.268-16.687-1.65-.937-3.613-1.339-5.711-1.829-1.115-.045-2.23-.134-3.346-.179-.715-.312-1.428-1.16-2.053-1.562-2.543-1.606-9.102-5.086-10.977-.491-1.205 2.9 1.785 5.755 2.811 7.228.76 1.026 1.74 2.186 2.277 3.346.311.758.4 1.562.713 2.365.713 1.963 1.383 4.149 2.32 5.979.49.937 1.025 1.919 1.65 2.767.357.491.982.714 1.115 1.517-.625.893-.668 2.231-1.025 3.347-1.607 5.042-.982 11.288 1.293 14.991.715 1.115 2.41 3.569 4.686 2.632 2.008-.803 1.561-3.346 2.141-5.577.135-.535.045-.892.312-1.249v.089c.625 1.249 1.25 2.454 1.83 3.703 1.383 2.186 3.793 4.462 5.801 5.979 1.07.803 1.918 2.187 3.256 2.677v-.135h-.088c-.268-.4-.67-.579-1.027-.892-.803-.803-1.695-1.785-2.32-2.677-1.873-2.498-3.523-5.265-4.996-8.12-.715-1.383-1.34-2.9-1.918-4.283-.27-.536-.27-1.339-.715-1.606-.67.981-1.65 1.83-2.143 3.034-.848 1.918-.936 4.283-1.248 6.737-.18.045-.09 0-.18.089-1.426-.356-1.918-1.829-2.453-3.078-1.338-3.168-1.562-8.254-.402-11.913.312-.937 1.652-3.882 1.117-4.774-.27-.848-1.16-1.338-1.652-2.008-.58-.848-1.203-1.918-1.605-2.855-1.07-2.499-1.605-5.265-2.766-7.764-.537-1.16-1.473-2.365-2.232-3.435-.848-1.205-1.783-2.053-2.453-3.48-.223-.491-.535-1.294-.178-1.829.088-.357.268-.491.623-.58.58-.491 2.232.134 2.812.401 1.65.669 3.033 1.294 4.416 2.23.625.446 1.295 1.294 2.098 1.518h.938c1.428.312 3.033.089 4.371.49 2.365.759 4.506 1.874 6.426 3.079 5.844 3.703 10.664 8.968 13.92 15.259.535 1.026.758 1.963 1.25 3.034.938 2.187 2.098 4.417 3.033 6.559.938 2.097 1.83 4.239 3.168 5.979.67.937 3.346 1.427 4.551 1.918.893.401 2.275.759 3.08 1.249 1.516.937 3.033 2.008 4.461 3.034.713.534 2.945 1.649 3.078 2.541z"
                        fill="#00678c"
                      />
                      <path
                        d="M133.566 56.114c-.758 0-1.293.089-1.828.223v.089h.088c.357.714.982 1.205 1.428 1.829.357.714.67 1.428 1.027 2.142l.088-.089c.625-.446.938-1.16.938-2.231-.268-.312-.312-.625-.535-.937-.268-.446-.848-.669-1.206-1.026z"
                        fill="#00678c"
                      />
                      <path
                        d="M85.916 128.215h16.776c1.963 0 3.838-.4 5.354-1.115 2.543-1.16 3.748-2.721 3.748-4.773v-4.283c0-1.65-1.383-3.213-4.148-4.283-1.428-.535-3.213-.848-4.953-.848h-7.049c-2.365 0-3.48-.715-3.793-2.275-.044-.178-.044-.357-.044-.535v-2.633c0-.135 0-.312.044-.49.312-1.205.937-1.518 2.99-1.74h17.177v-3.883H95.687c-2.365 0-3.614.135-4.729.492-3.436 1.07-4.953 2.766-4.953 5.754v3.393c0 2.631 2.945 4.863 7.942 5.398.535.045 1.115.045 1.695.045h6.024c.223 0 .445 0 .623.045 1.83.178 2.633.49 3.168 1.158.357.357.447.67.447 1.072v3.391c0 .4-.268.938-.803 1.383-.537.445-1.385.758-2.5.803-.223 0-.355.045-.58.045H85.916v3.879zM148.111 121.479c0 3.971 2.99 6.201 8.969 6.648.58.045 1.115.088 1.695.088h15.17v-3.881h-15.303c-3.393 0-4.686-.848-4.686-2.9v-20.078h-5.846v20.123h.001zM115.496 121.656v-13.83c0-3.525 2.498-5.668 7.363-6.336.535-.045 1.07-.09 1.561-.09h11.064c.58 0 1.072.045 1.652.09 4.863.668 7.316 2.811 7.316 6.336v13.83c0 2.855-1.025 4.373-3.436 5.4l5.711 5.174h-6.736l-4.641-4.193-4.686.268h-6.246c-1.025 0-2.186-.133-3.391-.445-3.701-1.028-5.531-2.991-5.531-6.204zm6.291-.31c0 .178.09.355.135.58.312 1.605 1.828 2.498 4.148 2.498h5.266l-4.818-4.373h6.736l4.238 3.838c.805-.447 1.295-1.072 1.473-1.875.045-.178.045-.4.045-.58v-13.252c0-.178 0-.355-.045-.535-.312-1.516-1.828-2.363-4.104-2.363h-8.791c-2.588 0-4.283 1.115-4.283 2.898v13.164zM176.623 128.26h.848v-3.256h1.115v-.67h-3.123v.67h1.16v3.256zm6.469 0h.803v-3.926h-1.203l-.982 2.678-1.07-2.678h-1.16v3.926h.758v-2.988h.045l1.115 2.988h.58l1.115-2.988v2.988h-.001z"
                        fill="#ce8b2c"
                      />
                    </g>
                  </svg>
                </CircularProgressbarWithChildren>
              </div>
              <p className="skill-name">{skillName}</p>
              <p className="skill-level">{level}</p>
            </div>
          </div>
        </div>
      </section>
      <section id="section4" className="section section4">
        <div className="content">
          <h2>最近の投稿</h2>
          <div className="posts">
            {data.allMicrocmsBlog.edges.map(function ({ node }) {
              let imgUrl = ""

              // アイキャッチがあるかの判断
              if (!node.eyecatch) {
                imgUrl = "/thumb.jpg"

              } else {
                imgUrl = node.eyecatch.url
              }

              return (
                <article className="post" key={node.id}>
                  <Link to={`blog/post/${node.slug}`}>

                    <figure>
                      <img src={imgUrl} alt="" />
                    </figure>
                    <h3 className="post-title">{node.title}</h3>
                  </Link>
                </article>
              )
            })}
          </div>
          <div className="blog-btn">
            <Link to="/blog">もっと見る</Link>
          </div>
        </div>
      </section>

      <section id="section5" className="section section5">
        <div className="content">
          <h2>お問い合わせ</h2>
          <form
            className="contact-form"
            name="contact"
            method="post"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
          >
            <input type="hidden" name="form-name" defaultValue="contact" />
            <div className="contact-form--info">
              <div className="contact-form--info__name info__name">
                <label htmlFor className="info__name--label">
                  お名前
                  <input
                    type="text"
                    name="name"
                    className="info__name--input"
                  />
                </label>
              </div>
              <div className="contact-form--info__mail info__mail">
                <label htmlFor className="info__mail--label">
                  メールアドレス
                  <input
                    type="email"
                    name="email"
                    className="info__mail--input"
                  />
                </label>
              </div>
            </div>
            <div className="contact-form--body">
              <label htmlFor className="contact-form--body__label">
                内容
                <textarea
                  name="message"
                  className="contact-form--body__input"
                />
              </label>
            </div>
            <div className="contact-form--submit">
              <button className="contact-form--submit__btn">送信</button>
            </div>
          </form>
        </div>
      </section>

      <Nav />
      {/* <Navigation /> */}
    </Layout>
  )
}

export const query = graphql`
  query {
    file(relativePath: { eq: "profile.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 200) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    allMicrocmsBlog(sort: {order: DESC, fields: publishDate}, limit: 5, skip: 0) {
      edges {
        node {
          title
          id
          slug
          eyecatch{
            url
          }
        }
      }
    }
  }
`
